import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='term-life-insurance-faq' // '-section-container' will be appended dynamically
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          You&#39;ve got term life insurance questions, <WidowBlock>we&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-term-life-insurance'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'term-life-insurance-what-is-it',
              title: <>What is term <WidowBlock>life insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Term life or term insurance is simple: You determine the right amount of coverage you need (with the help of your advisor), then you figure out for how long you need coverage for and choose from the available periods. Once that time is up, so is your coverage. Looking for coverage that&#39;s more permanent&#63; Our{' '}
                    <Link
                      id='term-life-insurance-what-is-it-link'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      whole life insurance
                    </Link> lasts your entire life and has other benefits that you can use along the way. See how term life compares to our{' '}
                    <Link
                      id='term-life-insurance-compare-types-of-life-insurance-link'
                      linkUrl='/life-insurance/compare-types/'
                      variant='primaryDeemphasize'>
                      other types of life insurance
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-how-long-does-it-last',
              title: <>How long does term life <WidowBlock>insurance last&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    We have term insurance policies for 10 and 20 years or until you turn 80 years of age, but once those terms end, so does your coverage.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-will-premiums-increase',
              title: <>Will my premiums stay the same or increase <WidowBlock>each year&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    It depends on the type of coverage you get. We offer two: annual renewable and level premium.
                  </Typography>
                  <Typography nextElement='typography'>
                    Annual renewable term life insurance gives you coverage at a lower initial cost, but the premiums will increase every year as you get older.
                  </Typography>
                  <BulletedList
                    bulletType='filledCircle'
                    bulletedListData={[
                      {
                        bulletText: <>
                          <Typography nextElement='typography'>
                            <strong>
                              Term 80
                            </strong>
                            {' '}is our longest coverage term that lasts until age 80.
                          </Typography>
                        </>,
                      },
                      {
                        bulletText: <>
                          <Typography nextElement='typography'>
                            <strong>
                              Term 10
                            </strong>
                            {' '}is our most affordable coverage that lasts for up to 10 years.
                          </Typography>
                        </>,
                      },
                    ]}
                  />
                  <Typography nextElement='typography'>
                    With level premium term life insurance, your premiums will stay the same throughout the term.
                  </Typography>
                  <BulletedList
                    bulletType='filledCircle'
                    bulletedListData={[
                      {
                        bulletText: <>
                          <Typography nextElement='typography'>
                            <strong>
                              Level Term 20
                            </strong>
                            {' '}covers you for 20 years and your premiums will not go up throughout the entire period.
                          </Typography>
                        </>,
                      },
                      {
                        bulletText: <>
                          <Typography nextElement='typography'>
                            <strong>
                              Level Term 10
                            </strong>
                            {' '}also gives you coverage for 20 years, but the premiums will increase for the second 10&#45;year period.
                          </Typography>
                        </>,
                      },
                    ]}
                  />
                  <Typography disableBottomPadding>
                    <Link
                      id='term-life-insurance-will-premiums-increase-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Talk to an advisor about which type of term life is right for you
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-outlive-term-life',
              title: <>What happens if I outlive my term <WidowBlock>life insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Once the term of your policy ends, so does your coverage. Ideally, you wouldn&#39;t need it anymore. But if you&#39;re in a situation where you still have loved ones who rely on you financially or mortgage payments, you might want to consider buying a new policy. With a term policy from Northwestern Mutual, you can convert some or all of it to a whole life policy that gives you lifelong coverage and builds cash value you can use for anything throughout your life.<sup>2</sup>{' '}
                    <Link
                      id='term-life-insurance-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with an advisor to explore your options
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-term-or-whole-life',
              title: <>Which is better: term or <WidowBlock>whole life&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The best one for you depends on your goals. The biggest difference is that term life insurance covers you for a set amount of time and is likely to be less expensive than whole life insurance.
                  </Typography>
                  <Typography disableBottomPadding>
                    On the other hand,{' '}
                    <Link
                      id='term-life-insurance-term-or-whole-life-link'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      whole life insurance
                    </Link>
                    {' '}covers you for life and it has a lot more you can use throughout your life. It gives you the chance to increase coverage as your needs change. Whole life builds cash value over time &#40;tax&#45;deferred&#41; that you can use for anything.<sup>2</sup> Plus, it can earn dividends &#40;while not guaranteed, we&#39;ve paid them every year since 1872&#41; that can be taken as cash, used to pay premiums, or buy more coverage.{' '}
                    <Link
                      id='term-life-insurance-term-or-whole-life-pros-and-cons-link'
                      linkUrl='/life-and-money/which-is-better-term-or-whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      Find out the pros and cons of term life vs. whole life
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-is-coverage-enough',
              title: <>Isn&#39;t work <WidowBlock>coverage enough&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    It&#39;s a great perk, but life insurance offered through your employer usually won&#39;t give you the amount of coverage you may need. Typically, you want around 10 times your annual salary, but most employers offer only one to two times your annual salary. Also, if you leave your job or go out on your own, you can&#39;t take your coverage with you. And when it comes to affordability, the younger you get covered the less expensive it will be. <Link
                      id='term-life-insurance-is-coverage-enough-link'
                      linkUrl='/life-insurance/life-insurance-calculator/'
                      variant='primaryDeemphasize'>
                      Calculate how much life insurance coverage you&#39;ll need
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-is-it-affordable',
              title: <>Is term life <WidowBlock>insurance affordable&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Surprisingly so, but the cost depends on things like your age, health, as well as the amount and length of coverage you need. A &#36;500k policy that would cover you up to age 80 for a 35&#45;year&#45;old female will initially cost about 72&#162; per day, and for a 35&#45;year&#45;old male it&#39;s only 87&#162; per day initially.<sup>1</sup> The best way to get an accurate quote is to{' '}
                    <Link
                      id='term-life-insurance-is-it-affordable-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      talk to an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-does-it-have-cash-value',
              title: <>Does term life insurance have <WidowBlock>cash value&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Term life insurance does not build cash value like{' '}
                    <Link
                      id='term-life-insurance-faq-cash-value-whole-link'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      whole life
                    </Link>
                    ,{' '}
                    <Link
                      id='term-life-insurance-faq-cash-value-universal-link'
                      linkUrl='/life-insurance/universal-life-insurance/'
                      variant='primaryDeemphasize'>
                      universal life
                    </Link>
                    , or{' '}
                    <Link
                      id='term-life-insurance-faq-cash-value-variable-universal-link'
                      linkUrl='/life-and-money/how-variable-universal-life-insurance-works/'
                      variant='primaryDeemphasize'>
                      variable universal life
                    </Link>
                    {' '}does. That means as you make payments, part of it won&#39;t go toward building a pool of money over time. This savings component typically grows tax deferred and gives you the option to withdraw or borrow against it for whatever you need throughout your life. It can come in handy for unexpected expenses, paying for college, expanding your business, upgrading your home, or as additional income in retirement.<sup>2</sup>{' '}
                    <Link
                      id='term-life-insurance-faq-cash-value-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Connect with an advisor to explore your options
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-what-riders',
              title: <>What riders are available for <WidowBlock>term insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Our term life insurance policies have an optional waiver of premium rider to give you more flexibility. This benefit lets you stop paying your life insurance premiums if you ever experience a qualifying disability, while still keeping your coverage with no reduction to the death benefit. Learn more about our <Link
                      id='term-life-insurance-faq-available-riders-life-link'
                      linkUrl='/life-insurance/life-insurance-riders/'
                      variant='primaryDeemphasize'>
                      insurance riders
                    </Link>
                    {' '}or{' '}
                    <Link
                      id='term-life-insurance-faq-available-riders-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      ask an advisor
                    </Link>
                    {' '}which one is right for you.
                  </Typography>
                </>
              ),
            },
            {
              id: 'term-life-insurance-what-is-term-conversion',
              title: <>What is <WidowBlock>term conversion&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    When you&#39;re younger, term life insurance can be a simple way to protect your loved ones. But as life changes your financial priorities can too, so you may want to have whole life insurance for its lifetime coverage and additional benefits that you can use while you&#39;re living. That&#39;s where a{' '}
                    <Link
                      id='term-life-insurance-faq-term-conversion-link'
                      linkUrl='/life-insurance/term-life-insurance/convertible-term-life-insurance/'
                      variant='primaryDeemphasize'>
                      term conversion
                    </Link>
                    {' '}comes in.
                  </Typography>
                  <Typography disableBottomPadding>
                    As a Northwestern Mutual term policyowner, you can convert some or all of your term coverage into a{' '}
                    <Link
                      id='term-life-insurance-faq-whole-life-insurance-link'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      variant='primaryDeemphasize'>
                      whole life policy
                    </Link>.
                    {' '}Approval is guaranteed regardless of your health. The premiums won&#39;t increase once they&#39;re set, but they will go up with age, so it&#39;s a good idea to lock them in early.{' '}
                    <Link
                      id='term-life-insurance-faq-whats-term-conversion-link'
                      linkUrl='/life-and-money/what-is-term-conversion/'
                      variant='primaryDeemphasize'>
                      Find out more about how a term conversion works
                    </Link>.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
